export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: 30,
  },
  title: {
    fontSize: 24,
    fontFamily: "'Proxima Nova', sans-serif",
    marginBottom: 60,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '80%',
  },
}
